// Stage 2 "Dashboard" · 2.3 (f) — Misstatements vs materiality: one bar per engagement (W9 uncorrected aggregate against PM);
// the colour is the API's band (< 50 % green, 50 % to < 100 % amber, ≥ PM red — one home, backend firm_dashboard.pm_band);
// each bar opens W9 for that engagement.
import React from "react";
import { fmtNumber } from "@/lib/format";
import { FD, BAND_COLOR, TARGET, fill } from "./fdTheme";
import { FdLink, Panel, Empty } from "./FdPrimitives";
import NumPair from "@/components/NumPair";

export default function FdMisstatements({ rows, t, lang }) {
  const list = Array.isArray(rows) ? rows : [];
  const n = (v, o) => fmtNumber(v || 0, lang, o);
  return (
    <Panel title={t("fd.ms.title")} hint={t("fd.ms.hint")} testid="fd-misstatements">
      {list.length === 0 ? <Empty>{t("fd.ms.empty")}</Empty> : (
        <ul className="space-y-2">
          {list.map((r) => {
            const id = r.engagement_id;
            const band = BAND_COLOR[r.band] ? r.band : "none";     // F4: the API's band only (the one rule lives in firm_dashboard.pm_band)
            const width = r.pct === null || r.pct === undefined ? 0 : Math.max(2, Math.min(100, Number(r.pct)));
            return (
              <li key={id}>
                <FdLink to={TARGET.w9} engId={id} testid={`fd-ms-row-${id}`} className="rounded px-2 py-1.5" style={{ background: FD.cell }}>
                  <div className="flex flex-wrap items-baseline justify-between gap-x-3 text-sm">
                    <span className="font-medium">{r.client_name}</span>
                    <span className="tabular-nums text-xs" style={{ color: FD.muted }}>
                      {r.pm ? <><NumPair parts={[n(r.aggregate), n(r.pm)]} /> · {fill(t("fd.ms.ofPm"), { pct: n(r.pct, { maximumFractionDigits: 0 }) })}</> : t("fd.ms.noPm")}
                    </span>
                  </div>
                  <div className="mt-1 h-3 w-full overflow-hidden rounded" style={{ background: "#E7E3D8" }} role="img" aria-label={`${r.client_name}: ${n(r.pct, { maximumFractionDigits: 0 })}%`}>
                    <div data-testid={`fd-ms-bar-${id}`} data-band={band} className="h-full rounded" style={{ width: `${width}%`, backgroundColor: BAND_COLOR[band] || FD.grey }} />
                  </div>
                </FdLink>
              </li>
            );
          })}
        </ul>
      )}
    </Panel>
  );
}
